@if (textHeader) {
  <label class="fw-medium fs-base-l0 text-black-neutrals">
    {{ textHeader }}
  </label>
}
<input
  type="file"
  hidden
  [accept]="accept"
  #fileUpload
  [disabled]="disable"
  (change)="selectFile($event)"
/>

<div class="bg-white">
  <ngx-file-drop
    class="file-drop pointer"
    dropZoneLabel="Browse or Drop files here"
    (onFileDrop)="dropped($event)"
    (click)="fileUpload.click()"
  >
    <ng-template
      ngx-file-drop-content-tmp
      let-openFileSelector="openFileSelector"
    >
      <div
        class="d-flex flex-column align-items-center gap-1 text-gray-pantone"
      >
        <svg
          class="pointer icon-size-res"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <use
            href="assets/images/icons/apps/window-arrow-up.svg#window-arrow-up"
          ></use>
        </svg>
        <div>
          <span class="fw-bold fs-base-l2 text-blue-tang ps-2 my-1">
            {{
              'MEMOS.Choose a file or drag & drop it here' | translate
            }}
          </span>
        </div>
        @if (showTextHint) {
          <div class="fs-base-l4 text-red-scarlet px-3 text-center">
            {{
              'MEMOS.The maximum size limit per file is 25 MB and the total files size limit is 45 MB'
                | translate
            }}
          </div>
        }
        <div class="my-1">
          <button
            class="btn btn-std btn-h btn-std-2ry fs-base-l4 fw-semibold mx-1 py-base-l8 px-base-l4 btn-width"
            type="button"
          >
            {{ 'COMMON.UPLOAD-FILE' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </ngx-file-drop>
  @if (fileInput && !previewExampleFile) {
    <div
      class="fs-base-l2 fw-medium d-flex align-items-center my-3 justify-content-between"
    >
      {{ fileInput.name }}
      <div class="pointer">
        <a class="text-asterisk" (click)="deleteFile()">
          <i class="fas fa-times"></i>
        </a>
      </div>
    </div>
  }

  @if (fileInput && previewExampleFile && !showMultiFile) {
    <div>
      <div
        class="d-flex justify-content-between align-items-center my-3 p-3 upload-name-style"
      >
        <div class="px-3">
          @if (urls[0]) {
            <img
              [style.object-fit]="'contain'"
              [src]="urls[0]"
              height="59"
              width="45"
            />
          }
          @if (!urls[0]) {
            <svg class="pointer icon-btn-svg preview-mini">
              <use [attr.href]="href[0]" height="59" width="45"></use>
            </svg>
          }
        </div>
        <div class="file-name">
          {{ fileInput.name }}
          <div class="fs-base-l7 text-gray-neutrals mt-1">
            {{ fileInput.size / (1024 * 1024) | number: '1.2-2' }} mb
          </div>
        </div>
        <div (click)="deleteFile()">
          <div class="pointer">
            <a class="text-asterisk">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  }
  @if (previewExampleFile && showMultiFile) {
    <div>
      @for (file of files; track file; let i = $index) {
        <div
          class="d-flex justify-content-between align-items-center my-3 p-3 upload-name-style"
        >
          <div [style.width.px]="10">
            {{ i + 1 }}
          </div>
          <div class="px-3">
            @if (urls[i]) {
              <img
                [style.object-fit]="'contain'"
                [src]="urls[i]"
                height="59"
                width="45"
              />
            }
            @if (!urls[i]) {
              <svg class="pointer icon-btn-svg preview-mini">
                <use
                  [attr.href]="href[i]"
                  height="59"
                  width="45"
                ></use>
              </svg>
            }
          </div>
          <div class="file-name">
            {{ file.name }}
            <div class="fs-base-l7 text-gray-neutrals mt-1">
              {{ file.size / (1024 * 1024) | number: '1.2-2' }} mb
            </div>
          </div>
          <div (click)="removeFile(i, file)">
            <div class="pointer">
              <a class="text-asterisk">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
